export const UI_VARIABLES = {
    POPOVERBGCOLOR:"#fff",
    POPOVERICONCOOR:"#000",
  };